import { OptionSelector, PageSection, PageWrapper } from '@src/components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { DashboardView, PayoutView } from './components';

export type AffiliateTab = 'dashboard' | 'payout';

export function Affiliate() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab') as AffiliateTab | null;

  const [activeTab, setActiveTab] = useState<AffiliateTab>('dashboard');
  const tabOptions: AffiliateTab[] = ['dashboard', 'payout'];

  useEffect(() => {
    if (tabOptions.includes(tabParam as AffiliateTab)) {
      setActiveTab(tabParam as AffiliateTab);
    } else {
      setSearchParams({ tab: 'dashboard' });
    }
  }, [tabParam, setSearchParams]);

  const handleTabChange = (key: AffiliateTab | null) => {
    if (!key) return;
    setActiveTab(key);
    setSearchParams({ tab: key });
  };
  return (
    <PageWrapper title={t('pages.affiliate.title')}>
      <PageSection className='bg-wl-background py-2 sm:py-4 sm:px-6 mb-4 sm:mb-6'>
        <OptionSelector<AffiliateTab>
          options={tabOptions}
          selected={activeTab}
          onSelect={handleTabChange}
          className='md:[&>*]:w-[165px] [&>*]:w-full !pr-0'
          renderLabel={(key) =>
            key === 'dashboard'
              ? t('pages.affiliate.dashboard.title')
              : t('pages.affiliate.payout.title')
          }
        />
      </PageSection>
      {activeTab === 'dashboard' ? <DashboardView /> : <PayoutView />}
    </PageWrapper>
  );
}
